<template>
    <v-dialog v-model="shows" width="600">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title>로고 {{ isCreated ? "등록" : "수정" }}</v-card-title>
            <v-divider />
            <v-row no-gutters class="pa-3">
                <v-col cols="4">
                    <image-input v-model="form.image" outlined flat width="150" :aspect-ratio="1 / 1" />
                </v-col>
                <v-col cols="8" class="pt-3">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="form.subject" label="제목" outlined dense hide-details="auto" />
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="form.type" label="유형" :items="typeItems" outlined dense hide-details="auto" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider />
            <v-card-actions>
                <v-switch v-model="form.shows" class="ma-0 ml-2" label="적용" :inset="true" hide-details="auto" />
                <v-spacer />
                <v-btn @click="() => (shows = false)">취소</v-btn>
                <v-btn color="primary" v-bind="{ loading }" @click="save">{{ isCreated ? "등록" : "수정" }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import ImageInput from "../image-input.vue";
const initLogo = (logo = {}) => ({
    ...logo,
    subject: logo?.subject || "",
    image: logo?.image || "",
    type: logo?.type || "pc",
    shows: logo?.shows || false,
});
export default {
    components: {
        ImageInput,
    },
    props: {
        value: { type: Object, default: initLogo },
    },
    data: () => ({
        shows: false,
        loading: false,

        form: initLogo(),
        typeItems: [
            { text: "pc", value: "pc" },
            { text: "mobile", value: "mobile" },
        ],
    }),
    computed: {
        isCreated() {
            return !this.value._id;
        },
    },
    mounted() {
        this.sync();
    },
    methods: {
        sync() {
            this.form = initLogo(this.value);
        },

        async search() {
            if (this.isCreated) return;
            if (this.loading) return;
            this.loading = true;
            try {
                let { logo } = await api.console.common.logos.get({ _id: this.value._id });

                this.form = initLogo(logo);
            } catch (error) {
                alert(error);
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (this.loading) return;
            this.loading = true;
            try {
                let { image, ...form } = this.form;
                let { put, post } = api.console.common.logos;

                let { logo } = await (this.isCreated ? post : put)(form);

                if (image instanceof File) {
                    await api.console.common.logos.image.post(logo._id, image);
                }
                alert("저장되었습니다.");
                this.shows = false;
                this.$emit("update");
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        shows() {
            this.sync();
            if (this.shows) this.search();
        },
    },
};
</script>

<style>
</style>